<div [formGroup]="subForm" class="d-flex">
  <div class="mt-3 type-actions-list">
    <span for="label"><strong>{{variables.selectMetodology}}</strong></span>

    @if (listItem && listItem.length > 0) {
    <div class="list-group-control list-type-action mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-catalog-name">{{variables.metodology}}</div>
      </div>
      @for (item of listItem; track item; let i = $index) {
      <div class="list-group-control-item-meto" (click)="highlightItem(item, i)">
        <div class="list-group-control-item-name" id="item-{{i}}">
          <span class="dot"></span>
          {{ item.metodology }}
        </div>
        <div class="list-group-control-item-icons action_buttons">
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.editMacro}}" (click)="editMethodologyDialog(item)"
            class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeMacro}}" (click)="openDialogRemoveType(item)"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listItem || listItem.length === 0) {
    <div class="mt-3"></div>
    }
    <!--@if ((authService.isAdmin() | async) ) {-->
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="addMethodologyDialog()"
      message="{{variables.addNewMetodology}}"></app-button>
    <!--}-->
  </div>
  @if (isActionsListVisible == true) {
  <mat-icon class="keyboard_arrow_right">keyboard_arrow_right</mat-icon>
  }
  @if (isActionsListVisible == true) {
  <div class="mt-3 actions-list">
    <span for="label"><strong>{{variables.manageMacroActivity}}</strong> ({{variables.descriptionMacroActivity}})</span>
    @if (listItem[currentIndex] && listItem[currentIndex].macroActivities.length > 0) {
    <div class="list-group-control list-actions mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-item-name">{{variables.name}}</div>
        <div class="list-group-control-item-complexity">{{variables.effort}} (%)</div>
        <div class="list-group-control-item-complexity">{{variables.maxHours}}</div>
        <div class="list-group-control-item-complexity">{{variables.profile}}</div>
        <div class="list-group-control-item-icons"></div>
      </div>
      @for (item of listItem[currentIndex].macroActivities; track item) {
      <div class="list-group-control-item-macro">
        <div class="list-group-control-item-name">{{ item.name }}</div>
        <div class="list-group-control-item-complexity">{{ item.effort}}</div>
        <div class="list-group-control-item-complexity">{{ item.maxHours ? item.maxHours : '-' }}</div>
        <div class="list-group-control-item-complexity">{{ getProfileName(item.profileId) }}</div>
        <div class="list-group-control-item-icons action_buttons">
          <!--@if ((authService.isAdmin() | async) ) {-->
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.editActivity}}" (click)="editMacroDialog(item)"
            class="icon-edit me-3 action_buttons-item">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>
          <!--}-->
          <!--@if ((authService.isAdmin() | async) ) {-->
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeActivity}}" (click)="openDialogRemoveMacro(item)"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
          <!--}-->
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listFilteredItem || listFilteredItem.length === 0) {
    <div class="mt-3"></div>
    }
    <!--@if ((authService.isAdmin() | async) ) {-->
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn addItemsBtnBigger" (click)="addMacroDialog()"
      message="{{variables.addNewMacro}}"></app-button>
    <!--}-->
  </div>
  }
</div>